var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remark"},[_vm._v(" 这里是说明 ")])}
var staticRenderFns = []

export { render, staticRenderFns }